import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function ErrorState({ message, onRetry }: { message?: string; onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 rounded-xl border border-red-200 bg-red-50 p-8 text-center"
      role="alert"
    >
      <AlertCircle className="h-6 w-6 text-red-600" aria-hidden="true" />
      <div className="text-sm font-medium text-red-900">{message ?? t('app.error')}</div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="rounded-lg border border-red-300 bg-white px-3 py-1.5 text-xs font-medium text-red-700 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-300"
        >
          {t('app.retry')}
        </button>
      )}
    </div>
  );
}
